const DEFAULT_STATIC_CONTENT_HOST = "https://static.hellocashflow.com";

const hasScheme = (value: string): boolean =>
  value.startsWith("http://") || value.startsWith("https://");

const normaliseHost = (raw: string): string => {
  const trimmed = raw.trim();
  if (!trimmed) {
    return "";
  }

  const withScheme =
    trimmed.startsWith("/") || hasScheme(trimmed)
      ? trimmed
      : `https://${trimmed}`;

  return withScheme.endsWith("/") ? withScheme.slice(0, -1) : withScheme;
};

/**
 * Base host for public static assets (images/videos) stored in the public static bucket.
 *
 * @remarks
 * The admin frontend only needs this host to render already-public asset URLs. Uploads are
 * backend-owned and use admin-authenticated signed URLs, so browser code must not derive or
 * guess bucket names from this value.
 *
 * @see docs/guides/STATIC_CONTENT.md
 */
export const getStaticContentHost = (): string => {
  return (
    normaliseHost(import.meta.env.VITE_STATIC_CONTENT_HOST ?? "") ||
    DEFAULT_STATIC_CONTENT_HOST
  );
};

export const joinStaticContentUrl = (path: string): string => {
  const host = getStaticContentHost();
  const trimmedPath = path.startsWith("/") ? path.slice(1) : path;
  return trimmedPath ? `${host}/${trimmedPath}` : host;
};
